import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { hospitals } from '../../../data/hospitals';

export default function HospitalsSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const displayHospitals = hospitals.slice(0, 6);

  const handleHospitalClick = (hospitalId: string) => {
    navigate(`/hospital/${hospitalId}`);
  };

  return (
    <section id="hospitals" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('hospitals_title')}
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {t('hospitals_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayHospitals.map((hospital) => (
            <div
              key={hospital.id}
              onClick={() => handleHospitalClick(hospital.id)}
              className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={hospital.image}
                  alt={i18n.language === 'ru' ? hospital.nameRu : hospital.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                  {i18n.language === 'ru' ? hospital.nameRu : hospital.name}
                </h3>
                <div className="flex items-start text-sm text-gray-600 mb-3">
                  <i className="ri-map-pin-line mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="leading-relaxed">{i18n.language === 'ru' ? hospital.addressRu : hospital.address}</span>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  {(i18n.language === 'ru' ? hospital.specialtiesRu : hospital.specialties).slice(0, 3).map((specialty, idx) => (
                    <span
                      key={idx}
                      className="px-2 py-1 bg-teal-50 text-teal-700 text-xs font-medium rounded"
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-teal-600 hover:text-teal-700 font-medium flex items-center whitespace-nowrap">
                    {t('view_details')}
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                  <button className="w-9 h-9 flex items-center justify-center bg-teal-50 text-teal-600 rounded-full hover:bg-teal-100 transition-colors">
                    <i className="ri-phone-line text-base"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/hospitals')}
            className="inline-flex items-center px-8 py-3 text-sm font-medium bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            {t('view_all_hospitals') || (i18n.language === 'ru' ? 'Все больницы' : 'Barcha shifoxonalar')}
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}